import DefaultLayout from 'components/layouts/default'
import services from 'services'
import PolicyTemplate from 'components/ui/policytemplate'

const UserApplicationPolicy = (props) => {
  return (
    <DefaultLayout
      title={props.title}
      headerType={2}
    >
      <PolicyTemplate
        dataTest="page-user-application-policy"
        pageTitle={props.title}
        pageUrl={props.pageUrl}
      >
        <div className="container">
          <div className="row">
            <div
              dangerouslySetInnerHTML={{
                __html: props.agreementDescription,
              }}
            />
          </div>
        </div>
      </PolicyTemplate>
    </DefaultLayout>
  )
}

UserApplicationPolicy.getInitialProps = async () => {
  let agreementDescription = ''
  let resp
  let params = { accountTypeId: 2 }

  try {
    resp = await services.wrapper(
      null,
      services.configs.agreements.userapplicationdatas.get,
      params
    )
  } catch (error) {
    //
  }

  if (resp && resp.data && resp.data.result.text) {
    agreementDescription = resp.data.result.text
  }
  return {
    agreementDescription,
    title: 'İlgili Kişi Başvuru Formu',
    pageUrl: '/ilgili-kisi-basvuru-formu',
  }
}

export default UserApplicationPolicy
